<template>
  <sidebar-menu :theme="theme" width="160px" width-collapsed="40px" :menu="menu" :collapsed="sidebarPinned" @toggle-collapse="$store.dispatch('togglePinSidebar')" showOneChild>
    <template #header>
      <div class="brand-logo">
        <b-navbar-brand class="p-0 m-0 text-white" to="/">
          <img :src="ecosystem.logo" :alt="ecosystem.siteName" v-if="!sidebarPinned">
          <img :src="ecosystem.logoPinned || ecosystem.logo" :alt="ecosystem.siteName" v-else>
          <div v-if="!sidebarPinned">
            {{ $appConfig.productName || '' }}
          </div>
        </b-navbar-brand>
      </div>
    </template>
    <template #footer></template>
  </sidebar-menu>
</template>

<script>
import { SidebarMenu } from 'vue-sidebar-menu'

export default {
  name: 'Sidebar',
  components: {
    SidebarMenu
  },
  data() {
    return {
      theme: '' // || 'white-theme'
    }
  },
  computed: {
    menu() {
      console.log('*** Eco Modules config', this.ecosystemModules)
      return [
        {
          header: true,
          title: this.$gettext('Control'),
          hiddenOnCollapse: true
        },
        {
          title: this.$gettext('Panels'),
          icon: 'fas fa-tachometer-alt',
          child: [
            {
              href: { name: 'shippingsSummary' },
              title: this.$gettext('Summary and Control')
            },
            {
              hidden: this.ecosystem.product === 'gcm2',
              href: { name: 'incidencesPanel' },
              title: this.$gettext('Incidences')
            },
            {
              hidden: !this.$store.getters.flexShippingTypeId,
              href: { name: 'flexesControl' },
              title: this.$gettext('FLEXES Control')
            },
            {
              hidden: !this.ecosystemModules.ocrControl,
              title: this.$gettext('OCR Control'),
              href: { name: 'OcrControl' },
              exactPath: true
            }
          ]
        },
        {
          title: this.$gettext('Map'),
          icon: 'fas fa-globe-americas',
          href: { name: 'map' }
        },
        {
          header: true,
          title: this.$gettext('Lists'),
          hiddenOnCollapse: true
        },
        {
          icon: 'fas fa-users',
          title: this.$gettext('Users'),
          href: { name: 'UsersList', params: { type: 'users' } },
          exactPath: true
        },
        {
          hidden: !this.ecosystemModules.tours.self,
          icon: 'fas fa-shipping-fast',
          title: this.$gettext('Tours'),
          href: { name: 'tourList' },
          exactPath: true
        },
        {
          hidden: !this.ecosystemModules.shippingOrders,
          icon: 'fas fa-file-alt',
          title: this.$gettext('Shipment Orders'),
          href: { name: 'ShippingOrdersList' },
          exactPath: true
        },
        {
          hidden: !this.ecosystemModules.shippings.self,
          icon: 'fas fa-boxes',
          title: this.$gettext('Shipments'),
          href: { name: 'ShippingsList' },
          exactPath: true
        },
        {
          icon: 'fas fa-money-bill-alt',
          title: this.$gettext('Transactions'),
          href: { name: 'TransactionsHistory' },
          exactPath: true,
          hidden: !this.ecosystemModules.transactions || !this.isGcmAdmin
        },
        {
          icon: 'fas fa-cogs',
          title: this.$gettext('Config'),
          hidden: !this.isGcmAdmin,
          child: [
            {
              href: { name: 'configGeneral' },
              title: this.$gettext('General'),
              exactPath: true
            },
            {
              hidden: this.ecosystem.product === 'gcm2',
              href: { name: 'configCommissions' },
              title: this.$gettext('Custom Commissions'),
              exactPath: true
            },
            {
              href: { name: 'configVehicles' },
              title: this.$gettext('Company Fleet'),
              exactPath: true
            },
            {
              title: this.ecosystemModules.stores.label || this.$gettext('Stores'),
              href: { name: 'StoresManagement' },
              exactPath: true,
              hidden: !this.ecosystemModules.stores.self || !this.isGcmAdmin
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
$primary-color: #4285f4 !default;
$base-bg: #2a2a2e !default;

$item-color: #ccc !default;

$item-active-color: null !default;
$item-active-bg: null !default;

$item-open-color: #fff !default;
$item-open-bg: $primary-color !default;

$item-hover-color: null !default;
$item-hover-bg: rgba(darken($base-bg, 5%), 0.5) !default;

$icon-color: null !default;
$icon-bg: darken( $base-bg, 5% ) !default;

$icon-active-color: null !default;
$icon-active-bg: null !default;

$icon-open-color: null !default;
$icon-open-bg: $item-open-bg !default;

$mobile-item-color: #fff !default;
$mobile-item-bg: $primary-color !default;
$mobile-icon-color: $mobile-item-color !default;
$mobile-icon-bg: $mobile-item-bg !default;

$dropdown-bg: lighten( $base-bg, 5% ) !default;
$dropdown-color: null !default;

$item-font-size: 1em !default;
$item-line-height: 20px !default;
$item-padding: 5px !default;
$icon-height: 30px !default;
$icon-width: 30px !default;
@import "vue-sidebar-menu/src/scss/vue-sidebar-menu.scss";
@import '/src/assets/scss/moova';

.v-sidebar-menu {
  transition: max-width .3s ease, left .3s ease;
  z-index: 10002;
  box-shadow: 0 0 20px rgba(0,0,0,.1);
  &.vsm_expanded {
    &.collapsed {
      left: -160px;
    }
  }
  &.vsm_collapsed {
    &.collapsed {
      left: -50px;
    }
  }
  a {
    text-decoration: none !important;
    &:hover {
      color: $primary;
    }
    &.vsm--link_exact-active,
    &.vsm--link_active,
    &.vsm--link_exact-active:hover,
    &.vsm--link_active:hover {
      color: #fff;
    }
  }
  .brand-logo {
    width: 100%;
    padding: 10px 5px;
    overflow: hidden;
    img {
      height: 100%;
      max-height: 50px;
      width: 100%;
      max-width: 150px;
    }
  }
  .vsm--header {
    font-weight: 100;
    font-size: .9em;
  }
}
</style>
